/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stx_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can view race statistics across multiple seasons using the season selector, with fantasy statistics available from the 2023 season onward. Comparing a driver across seasons shows whether their current form is a genuine trend or a short-term spike before you spend fantasy budget on them.`)
};

const es_f1_stx_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes ver estadísticas de carrera de varias temporadas usando el selector de temporada, con estadísticas fantasy disponibles desde la temporada 2023 en adelante. Comparar a un piloto entre temporadas muestra si su forma actual es una tendencia genuina o un repunte a corto plazo antes de gastar presupuesto de fantasy en él.`)
};

const de_f1_stx_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit der Saisonauswahl kannst du Rennstatistiken über mehrere Saisons hinweg ansehen; Fantasy-Statistiken sind ab der Saison 2023 verfügbar. Wenn du einen Fahrer über Saisons hinweg vergleichst, siehst du, ob seine aktuelle Form ein echter Trend oder nur ein kurzfristiger Ausreißer ist, bevor du Fantasy-Budget in ihn investierst.`)
};

const nl_f1_stx_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je kunt racestatistieken over meerdere seizoenen bekijken met de seizoenselector, waarbij fantasy-statistieken beschikbaar zijn vanaf het seizoen 2023. Door een coureur over seizoenen te vergelijken zie je of zijn huidige vorm een echte trend is of een kortetermijnpiek, voordat je fantasy-budget aan hem besteedt.`)
};

const fr_f1_stx_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez consulter les statistiques de course sur plusieurs saisons via le sélecteur de saison, les statistiques fantasy étant disponibles depuis la saison 2023. Comparer un pilote entre les saisons montre si sa forme actuelle est une tendance réelle ou un pic à court terme, avant de dépenser du budget fantasy sur lui.`)
};

const it_f1_stx_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi visualizzare le statistiche di gara su più stagioni usando il selettore di stagione, con le statistiche fantasy disponibili dalla stagione 2023 in poi. Confrontare un pilota tra le stagioni mostra se la sua forma attuale è una tendenza reale o un picco a breve termine, prima di spendere budget fantasy su di lui.`)
};

const pt_br2_f1_stx_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você pode ver estatísticas de corrida em várias temporadas usando o seletor de temporada, com estatísticas fantasy disponíveis a partir da temporada 2023. Comparar um piloto entre temporadas mostra se sua forma atual é uma tendência genuína ou um pico de curto prazo antes de você gastar orçamento fantasy nele.`)
};

const pt_f1_stx_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pode ver estatísticas de corrida em várias épocas usando o seletor de época, com estatísticas fantasy disponíveis a partir da época 2023. Comparar um piloto entre épocas mostra se a sua forma atual é uma tendência genuína ou um pico de curto prazo antes de gastar orçamento fantasy nele.`)
};

const ja_f1_stx_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズンセレクターを使って複数シーズンのレース統計を閲覧できます。ファンタジー統計は2023年シーズン以降利用可能です。シーズンをまたいでドライバーを比較することで、ファンタジー予算を投じる前に、現在のフォームが本物のトレンドなのか、短期的な急上昇にすぎないのかを見極められます。`)
};

const zh_f1_stx_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可以使用赛季选择器查看多个赛季的比赛统计数据,梦幻统计数据则从2023赛季起提供。跨赛季比较一位车手,能帮你在投入梦幻预算之前,判断他当前的状态是真正的趋势,还是短期的昙花一现。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stx_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stx_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stx_faq3_a", locale)
	if (locale === "en") return en_f1_stx_faq3_a(inputs)
	if (locale === "es") return es_f1_stx_faq3_a(inputs)
	if (locale === "de") return de_f1_stx_faq3_a(inputs)
	if (locale === "nl") return nl_f1_stx_faq3_a(inputs)
	if (locale === "fr") return fr_f1_stx_faq3_a(inputs)
	if (locale === "it") return it_f1_stx_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stx_faq3_a(inputs)
	if (locale === "pt") return pt_f1_stx_faq3_a(inputs)
	if (locale === "ja") return ja_f1_stx_faq3_a(inputs)
	return zh_f1_stx_faq3_a(inputs)
};